import React from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { connect } from "react-redux";
// import { getTransactionDataAction } from "../../actions/TransactionActions";
import { getPublicFormTransactionDataAction } from "../../actions/TransactionActions";
import {
  loginUserAction,
  logout,
  loginUserPublicFormsAction,
} from "../../actions/UserActions";
import {
  getContingencyData,
  convertTimeToMinutes,
  getTimeFromMins,
  formatPhoneNumber,
  toastMessage,
} from "../Common/Common";
import moment from "moment";
import html2pdf from "html2pdf.js";
import { addDocAction, uploadDocumentAction } from "./../../actions/DocActions";
import * as code from "./../../config/Constants";
import StickyHeaderPublic from "./StickyHeaderPublic";
import FooterPublic from "./FooterPublic";
var _ = require("lodash");

// var systemLoginValues = {
//   email: process.env.REACT_APP_SYSTEMLOGINVALUES_EMAIL,
//   password: process.env.REACT_APP_SYSTEMLOGINVALUES_PASSWARD,
// };

class AfterCarePublic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contacts: [],
      transaction: [],
      clientFirstName: "",
      clientLastName: "",
      artistName: "",
      artistPhone: "",
      appointmentDate: "",
      transactionId: this.props.formData && this.props.formData.transactionId,
      errors: {},
    };

    this.exportFormToPDF = this.exportFormToPDF.bind(this);
  }

  loginForPublicForm() {
    let data = { WEbEOpurMgk: "5GfFObGWzC5PNVTVbMA" };
    return this.props.loginUserPublicFormsAction(data).then((loginRes) => {});
  }

  async getTransactionData() {
    //await this.props.loginUserAction(systemLoginValues);
    // await this.loginForPublicForm();

    let transaction = [];

    await this.props
      .getPublicFormTransactionDataAction(this.state.transactionId)
      .then((transDataRes) => {
        transaction.push(this.props.transactionData);
        for (let i = 0; i < transaction.length; i++) {
          let time =
            moment(
              getContingencyData(
                transaction[i].contingencies,
                "First Appointment",
                "startDate"
              )
            ).get("hour") +
            ":" +
            moment(
              getContingencyData(
                transaction[i].contingencies,
                "First Appointment",
                "startDate"
              )
            ).get("minutes");
          let timeToMins = convertTimeToMinutes(time);
          let minsToTime = getTimeFromMins(timeToMins);

          this.setState({
            clientFirstName: transaction[i].dsd.buyer[0].firstname,
            clientLastName: transaction[i].dsd.buyer[0].lastname
              ? transaction[i].dsd.buyer[0].lastname
              : "",
            artistName:
              transaction[i].dsd.listingAgents[0].firstname +
              " " +
              transaction[i].dsd.listingAgents[0].lastname,
            artistPhone: transaction[i].dsd.listingAgents[0].mobileNumber,
            appointmentDate:
              moment(
                getContingencyData(
                  transaction[i].contingencies,
                  "First Appointment",
                  "startDate"
                )
              ).format("MM/DD/YYYY") +
              " " +
              minsToTime,
          });
        }
      });
  }

  componentDidMount() {
    this.getTransactionData();
  }

  async exportFormToPDF() {
    //localStorage.setItem("EMAIL", systemLoginValues.email);
    // await this.props.loginUserAction(systemLoginValues).then((loginRes) => {});
    // await this.loginForPublicForm();

    let form = document.getElementById("formToExport");

    //Setup the filename
    const dt = new Date();
    let filestamp =
      "_" +
      dt.getFullYear().toString() +
      (dt.getMonth() + 1).toString() +
      dt.getDate().toString() +
      dt.getHours().toString() +
      dt.getMinutes().toString() +
      dt.getSeconds().toString();

    let clientFullName =
      this.state.clientFirstName.trim() +
      (this.state.clientLastName ? " " + this.state.clientLastName.trim() : "");
    let fileName =
      "aftercare" +
      (clientFullName ? "_" + clientFullName : "") +
      filestamp +
      ".pdf";
    let fn = fileName.split(" ").join("_");

    //Set the pdf Export Options
    let opt = {
      margin: 1.5,
      filename: fn,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2.5, width: 1000 },
      jsPDF: { unit: "in", format: "a1", orientation: "p" },
    };

    html2pdf().set(opt).from(form).save();
    this.props.logout();
    toastMessage(code.SUCCESS, "Form downloaded successfully");
  }

  errorHandler(errors) {
    this.setState({
      errors: errors,
    });
  }

  render() {
    // console.log("systemLoginValues-98", systemLoginValues);
    return (
      <div className="admin-steps admin-content-area">
        <StickyHeaderPublic
          form={this.props.formData && this.props.formData.form}
          exportFormToPDF={this.exportFormToPDF.bind(this)}
          errorHandler={this.errorHandler.bind(this)}
          transaction={this.state}
        />
        <div className="container-custom">
          <Form className="form-sm form-admin" id="formToExport">
            <Row>
              <Col xs={12} sm={7}>
                <Row>
                  <Col xs={12}>
                    <h4 className="title-medium font-600 mt-5 mb-3 pt-3">
                      Aftercare Instructions
                    </h4>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>
                    Client First Name<span className="text-danger"> *</span>:
                  </Form.Label>
                  <Form.Control
                    value={
                      this.state.clientFirstName
                        ? this.state.clientFirstName
                        : ""
                    }
                    onChange={(e) =>
                      this.setState({ clientFirstName: e.target.value })
                    }
                    isInvalid={!!this.state.errors.clientFirstName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.errors.clientFirstName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Client Last Name:</Form.Label>
                  <Form.Control
                    value={
                      this.state.clientLastName ? this.state.clientLastName : ""
                    }
                    onChange={(e) =>
                      this.setState({ clientLastName: e.target.value })
                    }
                    isInvalid={!!this.state.errors.clientLastName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.errors.clientLastName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Appointment Date/Time:</Form.Label>
                  <Form.Control
                    type="text"
                    name="appointment"
                    id="appointment"
                    value={
                      this.state.appointmentDate
                        ? this.state.appointmentDate
                        : ""
                    }
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Artist Name:</Form.Label>
                  <Form.Control
                    type="text"
                    name="artistName"
                    id="artistName"
                    value={this.state.artistName ? this.state.artistName : ""}
                  />
                </Form.Group>
              </Col>
              {/* <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Artist Phone:</Form.Label>
                  <Form.Control
                    type="text"
                    name="artistPhone"
                    id="artistPhone"
                    value={
                      this.state.artistPhone
                        ? formatPhoneNumber(this.state.artistPhone)
                        : ""
                    }
                  />
                </Form.Group>
              </Col> */}
            </Row>
            <Row>
              <Col xs={12} sm={7}>
                <Row>
                  <Col xs={12}>
                    <h4 className="title-medium font-600 pt-3">DAY 1-5</h4>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={8}>
                <h4 className="title-small font-600 mb-3 pt-3">
                  If your tattoo is wrapped:
                </h4>
                <ul>
                  <li>Don't do anything yet</li>
                  <li>
                    Your artist will advise you how long to leave it wrapped
                    post-appointment
                  </li>
                </ul>
                <h4 className="title-small font-600 mb-3 pt-3">
                  If your tattoo is unwrapped or wrap is taken off early:
                </h4>
                <ul>
                  <li>
                    Wash your tattoo with antibacterial soap{" "}
                    <b>3 TIMES DAILY</b>
                  </li>
                  <li>
                    Lightly dab it dry and let air dry for <b>5-10 MINUTES</b>
                  </li>
                  <li>Apply a light layer of ointment after washing</li>
                </ul>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={7}>
                <Row>
                  <Col xs={12}>
                    <h4 className="title-medium font-600 mt-2 mb-3 pt-3">
                      DAY 5-14
                    </h4>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={8}>
                <ul>
                  <li>
                    Wash your tattoo with antibacterial soap{" "}
                    <b>2 TIMES DAILY</b>
                  </li>
                  <li>
                    Apply <b>UNSCENTED</b> lotion as needed
                  </li>
                  <li>
                    <b>DON'T</b> scratch or pick at your tattoo while it's
                    healing
                  </li>
                </ul>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={7}>
                <Row>
                  <Col xs={12}>
                    <h4 className="title-medium font-600 mt-2 mb-3 pt-3">
                      Questions? Concerns? Please contact your artist!
                    </h4>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </div>
        <FooterPublic
          form={this.props.formData && this.props.formData.form}
          exportFormToPDF={this.exportFormToPDF.bind(this)}
          errorHandler={this.errorHandler.bind(this)}
          transaction={this.state}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    transactionData: state.reducer.transactionData,
  };
};

export default connect(mapStateToProps, {
  addDocAction,
  uploadDocumentAction,
  getPublicFormTransactionDataAction,
  loginUserAction,
  logout,
  loginUserPublicFormsAction,
})(AfterCarePublic);
